export default __webpack_public_path__ + "images/MJ.3c6e1d3.png";